import { PurchaseOptionType } from '@/types/productServerApi';
import useBasket from '@/storecontext/basket/useBasket';
import useProductClickAndCollect from '@/shared/product/purchase/ui/useProductClickAndCollect';
import { computed } from 'vue';
import { useModuleConfigurator } from '@/shared/product/details/ui/module-configurator/useModuleConfigurator';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
const { storeId } = useProductClickAndCollect();
const { clickAndCollectStoreId } = useBasket();
const {
    addInstant,
    addPickAndPack,
    addClickAndCollect,
    addRegular,
    addOrUpdateModuleConfiguration,
} = useBasket();

const { moduleConfiguratorTileData } = useModuleConfigurator();

export function useAddToBasket() {
    const relevantStoreId = computed(() => storeId.value ?? clickAndCollectStoreId.value);
    const configurationId = useRouteQuery(QueryKeys.PDPConfigurationId);

    const addToBasket = async(id: string, purchaseType: PurchaseOptionType, quantity: number = 1, relatedItemId?: number) => {
        switch (purchaseType) {
        case PurchaseOptionType.Instant:
            await addInstant({
                itemId: id,
                quantity,
            });
            break;
        case PurchaseOptionType.PickAndPack:
            await addPickAndPack({
                sku: id,
                quantity,
                relatedItemId,
            });
            break;
        case PurchaseOptionType.ClickAndCollect:
            await addClickAndCollect({
                sku: id,
                quantity: quantity,
                clickAndCollectStoreId: relevantStoreId.value!,
                relatedItemId,
            });
            break;
        case PurchaseOptionType.ModuleConfiguration:
            await addOrUpdateModuleConfiguration(configurationId.value, moduleConfiguratorTileData.value);
            break;
        default:
            await addRegular({
                sku: id,
                quantity,
                relatedItemId,
            });
        }
    };

    return {
        addToBasket,
    };
}
